import React, { useState, useEffect, useCallback } from "react";
import "../Styles/Setting.css";
import Categories from "../components/Modals/Categories";
import Renew from "../components/Modals/Renew";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import ReLoginModal from "../components/ReLoginModal";
import { CircularProgress, Skeleton, Stack, Alert } from "@mui/material";
import api from "../util/axios";

const Account = () => {
  const [addCat, setAddCat] = useState(false);
  const [addRenew, setAddRenew] = useState(false);
  const [reLogin, setReLogin] = useState(false);
  const [loading, setLoading] = useState(true); // Start with loading true
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null); // Add error state for fallback

  const handleAddCat = () => {
    setAddCat(!addCat);
  };

  const handleRenew = () => {
    setAddRenew(!addRenew);
  };

  const [getSetting, setGetSetting] = useState({
    _id: "",
    logo: "",
    businessName: "",
    email: "",
    lowStock: "",
    inventoryCategories: [],
    phone: "",
    emailNotifications: false,
    businessCategory: "",
    location: {
      address: "",
      city: "",
      state: "",
      country: "",
    },
  });
  const token = window.localStorage.getItem("token");

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);

  function querySetting() {
    setLoading(true);
    setError(null); // Reset error state
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/settings", {
        headers: headers,
      })
      .then((res) => {
        setGetSetting(res.data.data);
        console.log(res.data.data);
        setEditedSettings(res.data.data);
        setLoading(false);
      })
      .catch((error) => {
        if (
          error.response?.data?.message === "jwt expired" ||
          error.response?.data?.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
          setError(error.response?.data?.message || "Failed to fetch settings.");
        }
        toast.error(error.response?.data?.message || "Failed to fetch settings.");
        setLoading(false);
      });
  }

  useEffect(() => {
    querySetting();
  }, []);

  const handleImageChange = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files?.[0];
      setLoading(true);
      if (selectedFile) {
        setFile(selectedFile);
        setSelectedImage(URL.createObjectURL(selectedFile));
        try {
          const formData = new FormData();
          formData.append("image", selectedFile);
          const response = await api.post(
            `/upload-image`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const imageUrl = response.data.data;
          setSelectedImage(imageUrl);
          setLoading(false);
          toast.success("Image has been set! Please remember to save your settings");
        } catch (error: any) {
          const errorMessage =
            error.response?.data?.message || error.message || "Failed to upload image.";
          toast.error(errorMessage);
          console.error("Upload failed:", error);
          setSelectedImage(null);
          setFile(null);
          setLoading(false);
        }
      }
    },
    [token]
  );

  const [editedSettings, setEditedSettings] = useState({
    businessName: getSetting.businessName,
    email: "",
    phone: "",
    lowStock: "",
    inventoryCategories: [],
    emailNotifications: false,
    businessCategory: "",
    location: {
      address: "",
      city: "",
      state: "",
      country: "",
    },
  });

  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setEditedSettings((prevEditedSettings) => ({
      ...prevEditedSettings,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    setIsUploading(true);
    e.preventDefault();

    const patchData = {
      ...editedSettings,
      logo: selectedImage || getSetting.logo,
    };

    api
      .patch(
        `/settings/${getSetting._id}`,
        patchData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setGetSetting(res.data.data);
        Swal.fire({
          title: `Success!`,
          text: `${res.data.message}`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setIsUploading(false);
      })
      .catch((error) => {
        if (
          error.response?.data?.message === "jwt expired" ||
          error.response?.data?.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
          setIsUploading(false);
        }
        Swal.fire({
          title: `Error!`,
          text: `${error.response?.data?.message || "Failed to update settings."}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
      });
  };

  if (!loading && (error || !getSetting._id)) {
    return (
      <div className="branch">
        <ToastContainer />
        <h2>Account Settings</h2>
        {reLogin ? <ReLoginModal /> : null}
        <Alert severity="error">
          {error || "No settings data available. Please try again."}
        </Alert>
        <button
          onClick={querySetting}
          className="addBut cursor-pointer"
          style={{ marginTop: "20px" }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="branch">
      <ToastContainer />
      <h2>Account Settings</h2>
      {reLogin ? <ReLoginModal /> : null}
      <form onSubmit={handleSubmit} className="board111">
        <div className="info">
          <div className="upp">
            <div className="UpProfile">
              {selectedImage ? (
                <img src={selectedImage} alt="Selected" />
              ) : getSetting.logo ? (
                <img src={getSetting.logo} alt="Business Logo" />
              ) : (
                <div className="no-image">No Logo Available</div>
              )}
            </div>
            <input
              type="file"
              alt="Choose a file"
              accept="image/png, image/jpeg"
              name="logo"
              className="cursor-pointer"
              onChange={handleImageChange}
            />
            <button className="cursor-pointer" type="button">Choose File</button>
          </div>

          <div className="plan">
            <button type="button" onClick={handleRenew}>
              Renew
            </button>
          </div>
        </div>
        <div className="line"></div>
        {loading ? (
          <Stack spacing={2} sx={{ padding: '20px 60px' }}>
            <Skeleton variant="rectangular" height={2} sx={{ margin: '20px 0' }} />
            <div className="infos">
              <Skeleton variant="text" width="20%" sx={{ fontSize: '2rem', marginBottom: '1rem' }} />
              <div className="infoInput">
                <div className="flex gap-8">
                  <div>
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                  </div>
                  <div>
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="infos">
              <Skeleton variant="text" width="20%" sx={{ fontSize: '2rem', marginBottom: '1rem' }} />
              <div className="infoInput">
                <div className="flex gap-8">
                  <div>
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                  </div>
                  <div>
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                    <Skeleton variant="text" width="20%" sx={{ fontSize: '1rem', marginBottom: '8px' }} />
                    <Skeleton variant="rectangular" width={410} height={40} sx={{ marginBottom: '1rem' }} />
                  </div>
                </div>
              </div>
            </div>
            <Skeleton variant="rectangular" height={2} sx={{ margin: '20px 0' }} />
          </Stack>
        ) : (
          <>
            <div className="infos">
              <h2 className="mb-3">General</h2>
              <div className="infoInput">
                <div>
                  <div className="input">
                    <label>Name</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="businessName"
                      value={editedSettings.businessName || ""}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="input">
                    <label>Email</label>
                    <input
                      className="pl-2"
                      type="email"
                      name="email"
                      value={editedSettings.email || ""}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="input">
                    <label>Low Stock</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="lowStock"
                      disabled
                      value={editedSettings.lowStock || ""}
                    />
                  </div>
                  <div className="input">
                    <label>Category</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="businessCategory"
                      value={editedSettings.businessCategory || ""}
                      disabled
                    />
                  </div>
                </div>

                <div>
                  <div className="input">
                    <label>Phone</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="phone"
                      value={editedSettings.phone || ""}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="input">
                    <label>Referral Code</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="refcode"
                      disabled
                      value=""
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="input ">
                    <label>Email Notification</label>
                    <div className="flex gap-4 !items-center">
                      <input
                        className="pl-2 !w-full"
                        type="text"
                        disabled
                        value={editedSettings.emailNotifications ? "Enabled" : "Disabled"}
                      />
                      <input
                        className="!w-[20%]"
                        type="checkbox"
                        name="emailNotifications"
                        checked={editedSettings.emailNotifications}
                        onChange={handleEditChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="infos">
              <h2>Location</h2>
              <div className="infoInput">
                <div>
                  <div className="input">
                    <label>Address</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="address"
                      value={editedSettings.location?.address || ""}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="input">
                    <label>City</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="city"
                      value={editedSettings.location?.city || ""}
                      disabled
                    />
                  </div>
                </div>

                <div>
                  <div className="input">
                    <label>State</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="state"
                      value={editedSettings.location?.state || ""}
                      disabled
                    />
                  </div>
                  <div className="input">
                    <label>Country</label>
                    <input
                      className="pl-2"
                      type="text"
                      name="country"
                      value={editedSettings.location?.country || ""}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button type="submit" className="addBut cursor-pointer">
            {isUploading ? (
              <CircularProgress
                style={{ color: "white", width: "25px", height: "25px" }}
              />
            ) : (
              "Save Settings"
            )}
          </button>
        </div>

        <div className="line"></div>
        {addCat ? <Categories handleAddCat={handleAddCat} /> : null}
        {addRenew ? <Renew handleRenew={handleRenew} /> : null}
      </form>
    </div>
  );
};

export default Account;